import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { Leaf } from 'lucide-react';

/**
 * Hero animato in stile “La Sila”: immagine con lento zoom (Ken Burns),
 * testo in entrata (framer-motion), grana e bordo a onda in basso.
 * Riusato su /alloggi e /dove-mangiare per coerenza visiva.
 */
export function SilaHero({ image, badge, title, subtitle, minH = '60vh', icon: Icon = Leaf, testId = 'sila-hero', children }) {
  const reduce = useReducedMotion();
  return (
    <section className="relative isolate flex items-end overflow-hidden text-white" style={{ minHeight: minH }} data-testid={testId}>
      {image ? (
        <img src={image} alt={title || ''} className={reduce ? 'absolute inset-0 -z-10 h-full w-full object-cover' : 'sila-kb absolute inset-0 -z-10 h-full w-full object-cover'} />
      ) : (
        <div className="absolute inset-0 -z-10 bg-primary/80" />
      )}
      <div aria-hidden className="absolute inset-0 -z-10" style={{ background: 'linear-gradient(180deg, hsl(150 42% 8% / 0.30) 0%, hsl(150 42% 8% / 0.55) 55%, hsl(150 42% 8% / 0.9) 100%)' }} />
      <div className="grain-overlay absolute inset-0 -z-10 opacity-40" />
      <div className="sila-section w-full pb-20 pt-28">
        {badge && (
          <motion.span
            initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] backdrop-blur-md sm:text-xs">
            {Icon && <Icon className="h-3.5 w-3.5" style={{ color: 'hsl(var(--brand-sun))' }} />}{badge}
          </motion.span>
        )}
        <motion.h1
          initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.08, ease: [0.16, 1, 0.3, 1] }}
          className="mt-4 max-w-3xl font-display text-4xl font-bold leading-[1.05] tracking-tight drop-shadow-[0_2px_20px_rgba(0,0,0,0.4)] sm:text-5xl lg:text-6xl">{title}</motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.16, ease: [0.16, 1, 0.3, 1] }}
            className="mt-4 max-w-2xl text-lg text-white/90">{subtitle}</motion.p>
        )}
        {children && (
          <motion.div
            initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.24, ease: [0.16, 1, 0.3, 1] }}
            className="mt-6">{children}</motion.div>
        )}
      </div>
      <svg className="sila-wave -mb-1 absolute inset-x-0 bottom-0" viewBox="0 0 1440 60" preserveAspectRatio="none" style={{ height: 56 }} aria-hidden="true">
        <path d="M0,32 C240,64 480,0 720,20 C960,40 1200,64 1440,28 L1440,60 L0,60 Z" fill="hsl(var(--background))" />
      </svg>
    </section>
  );
}

export default SilaHero;
